import { Avatar, Button, Typography } from '@mui/material';
import { GetDocumentFile } from 'API/documents';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useLoader } from 'Hooks/useLoader';
import { BlueEye } from 'Images';
import { downloadFile } from 'Utils';

interface IDownload {
  docId: number;
  docType: number;
  docName: string;
}
export const Download = ({ docId, docType, docName }: IDownload) => {
  const { isLoading, setIsLoading, loader } = useLoader(
    '25',
    { width: '89px' },
    25,
    false
  );

  const documentDownloadHandler = async () => {
    setIsLoading(true);
    const documentFile = await GetDocumentFile(docType, docId);
    if (documentFile?.contentBase64)
      downloadFile(documentFile.contentBase64, 'pdf', docName);
    setIsLoading(false);
  };

  return (
    <>
      {isLoading ? (
        loader
      ) : (
        <Button
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            ':hover': {
              cursor: 'pointer',
              textDecoration: 'underline',
            },
          }}
          onClick={documentDownloadHandler}
        >
          <Avatar alt='' src={BlueEye} sx={{ width: '28px', height: '28px' }} />
          <Typography variant='body6' color='primary'>
            {Dictionary[DICTIONARY.Documents].download}
          </Typography>
        </Button>
      )}
    </>
  );
};
